import { render, staticRenderFns } from "./Hospitals.html?vue&type=template&id=300993ce&"
import script from "./Hospitals.js?vue&type=script&lang=js&"
export * from "./Hospitals.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports